import { Icon20Chain, Icon20CloudArrowUpOutline, Icon20Hearts2Outline } from '@vkontakte/icons';
import clientShare from 'img/empty-folder/light/client-share.png';
import uploadOriginals from 'img/empty-folder/light/upload-originals.png';
import React, { useCallback, useMemo } from 'react';
import { renderNewVigboAlbumModal } from 'reactApp/sections/VigboPage/renderNewVigboAlbumModal';
import styles from 'reactApp/ui/EmptyFolder/EmptyFolder.css';

const useUploadOriginals = () => {
    const Upload = useMemo(
        () => (
            <div className={styles.icon}>
                <Icon20CloudArrowUpOutline />
            </div>
        ),
        []
    );

    const onClick = useCallback(() => {
        renderNewVigboAlbumModal({ navigateToAlbum: true });
    }, []);

    const additionLinks = useMemo(() => {
        return <img className={styles.vigboProvocationPicture} src={uploadOriginals} />;
    }, []);

    return useCallback(() => {
        return {
            title: 'Загружайте исходники',
            annotation: 'Сохраняйте в Облаке отснятый материал, даже в RAW-формате',
            Icon: Upload,
            additionLinks,
            onClick,
        };
    }, [Upload, additionLinks, onClick]);
};

const useClientShare = () => {
    const Share = useMemo(
        () => (
            <div className={styles.icon}>
                <Icon20Chain />
            </div>
        ),
        []
    );

    const onClick = useCallback(() => {
        renderNewVigboAlbumModal({ navigateToAlbum: true });
    }, []);

    const additionLinks = useMemo(() => {
        return <img className={styles.vigboProvocationPicture} src={clientShare} />;
    }, []);

    return useCallback(() => {
        return {
            title: 'Делитесь с клиентами',
            annotation: 'Передавайте съёмки в оформленных галереях в Vigbo',
            Icon: Share,
            additionLinks,
            onClick,
        };
    }, [Share, additionLinks, onClick]);
};

const useMemory = () => {
    const Hearts = useMemo(
        () => (
            <div className={styles.icon}>
                <Icon20Hearts2Outline />
            </div>
        ),
        []
    );

    const onClick = useCallback(() => {
        renderNewVigboAlbumModal({ navigateToAlbum: true });
    }, []);

    return useCallback(() => {
        return {
            title: 'Дарите память',
            annotation: 'Создавайте для каждого персональную историю в кадрах',
            Icon: Hearts,
            onClick,
        };
    }, [Hearts, onClick]);
};

export const useVigbo = () => {
    const uploadOriginals = useUploadOriginals();
    const clientShare = useClientShare();
    const memory = useMemory();

    return { uploadOriginals, clientShare, memory };
};
